import React from "react";

const Legend = () => {
  const legendData = [
    { colorName: "Red", riskLevel: "High", color: "bg-danger", textColor: "#ffffff" },
    { colorName: "Orange", riskLevel: "Moderate", color: "custom-orange", textColor: "#000000" }, // Using custom color
    { colorName: "Yellow", riskLevel: "Mild", color: "bg-warning", textColor: "#000000" },
    { colorName: "Green", riskLevel: "No risk", color: "bg-success", textColor: "#ffffff" },
  ];

  return (
    // Main container with a soft shadow and padding for a "card" effect
    <div
      className="w-100 p-2 rounded-3"
      style={{
        maxWidth: "800px",
        backgroundColor: "#f8f9fa", // A light grey background
        boxShadow: "0 4px 8px rgba(0,0,0,0.05)", // A subtle shadow
      }}
    >
      {/* Using flexbox for horizontal layout with reduced gaps for single line */}
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ gap: "1rem" }}
      >
        {legendData.map((item, index) => (
          <div key={index} className="d-flex align-items-center">
            {/* Color swatch rectangle with color name inside */}
            <div
              className={`${item.color} d-flex align-items-center justify-content-center`}
              style={{
                width: "55px",
                height: "22px",
                borderRadius: "3px", // Make it a rectangle with slight rounding
                // Apply the custom orange color directly
                backgroundColor:
                  item.color === "custom-orange" ? "#fd7e14" : undefined,
                // Add a subtle border for lighter colors like yellow to ensure visibility
                border:
                  item.color === "bg-warning"
                    ? "1px solid rgba(0,0,0,0.1)"
                    : "none",
                color: item.textColor,
                fontSize: "0.65rem",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {item.colorName}
            </div>
            {/* Risk level text next to the rectangle */}
            <span
              className="text-secondary ms-1" // Softer text color with small left margin
              style={{ fontSize: "0.8rem", fontWeight: 500 }}
            >
              {item.riskLevel}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;

